"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPositiveZero = void 0;
exports.isPositiveZero = (value) => Object.is(value, 0);
//# sourceMappingURL=is-positive-zero.js.map